// DESCRIPTION: Attributes related models & functions

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, ) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.AttributesStringify = this.HyperMD.AttributesStringify || {}), );
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * Convert attributes as JSON object to attributes as string
     * @param attributes
     */
    function default_1(attributes, addCurlyBrackets) {
        if (addCurlyBrackets === void 0) { addCurlyBrackets = false; }
        var parts = [];
        for (var key in attributes) {
            if (attributes.hasOwnProperty(key)) {
                parts.push(" ");
                parts.push(key + "=");
                var value = attributes[key];
                if (value instanceof Array) {
                    parts.push(stringifyArray(value));
                }
                else {
                    parts.push(JSON.stringify(value));
                }
            }
        }
        parts.shift();
        if (addCurlyBrackets) {
            parts.unshift("{");
            parts.push("}");
        }
        return parts.join("");
    }
    exports.default = default_1;
    function stringifyArray(value) {
        var parts = ["["];
        value.forEach(function (v, i) {
            if (v instanceof Array) {
                parts.push(stringifyArray(v));
            }
            else {
                parts.push(JSON.stringify(v));
            }
            if (i + 1 !== value.length) {
                parts.push(", ");
            }
        });
        parts.push("]");
        return parts.join("");
    }
});
